import { Stack, Typography } from '@mui/material'
import { StoppageResponseDto } from '@operations/app/api'
import { StoppageDate } from '@operations/features/stoppage/components/Atoms/StoppageDate'
import { StoppageEquipments } from '@operations/features/stoppage/components/Atoms/StoppageEquipments'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

interface Props {
  stoppage: StoppageResponseDto
  isVesselVisit?: boolean
}
export const StoppageRecord = observer(({ stoppage, isVesselVisit }: Props) => {
  const theme = useMinimalsTheme()

  return (
    <Stack
      gap={{ xs: theme.customSpacing.xs, md: theme.customSpacing.m }}
      data-cy='stoppage-record-card'
    >
      <Stack
        direction='row'
        alignItems='center'
        gap={{ xs: theme.customSpacing.xs, md: theme.customSpacing.l }}
      >
        <StoppageDate date={stoppage.from} isForDashboard />
        <StoppageDate date={stoppage.to} isForDashboard />
      </Stack>

      <Stack>
        <Stack
          direction='row'
          alignItems='center'
          gap={{ xs: theme.customSpacing.xs, md: theme.customSpacing.l }}
        >
          <Typography variant='body2'>{stoppage.stoppageReason?.name}</Typography>

          <StoppageEquipments
            equipments={stoppage.equipments}
            isForDashboard
            isVesselVisit={isVesselVisit}
          />
        </Stack>

        <Typography variant='caption' color='secondary'>
          {stoppage.notes}
        </Typography>
      </Stack>
    </Stack>
  )
})
